module.exports = "fragment ChildContactFragment on Contact {\n  ...RelatedContactFragment\n  parent {\n    ...RelatedContactFragment\n  }\n}\n"